export default __webpack_public_path__ + "img/c085934cc4a3136cdea571390649197a.svg";